export const PUBLIC_DATASETS_PATH = "/vl-datasets";
export const PRIVATE_DATASETS_PATH = "/datasets";
